export enum UpgradePlanModalScreenName {
  UpgradePlan = 'upgrade-to-business',
}
